import "./Calendar.css";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {Calendar, Culture, momentLocalizer} from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import AppointmentDetails from "./components/AppointmentDetails/AppointmentDetails";
import { TransformedEvent } from "./Utils/ParsingUtil";
import { fetchData } from "./Utils/FetchData";
import { getPdfIntroData } from "./Utils/pdf/fetchPdfIntoduction";
import moment from "moment";
import DateRangePicker from "./components/DatePicker/DatePicker";
import Header from "./components/Header/Header";
import { initValue, germanTranslations } from "./CalendarProps/CalendarProps";
import { useCallbackState } from "./Utils/GlobalContext";
import FilterAppointments from "./components/FilterAppointmenst/FilterAppointments";
import { getColor } from "./CalendarProps/CalendarProps";
import Spinner from "./components/Spinner/Spinner";
const localizer = momentLocalizer(moment);

const FirmCalendar: React.FC = () => {
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [showPicker, setShowPicker] = useState(false);
  const [filter, setFilter] = useState(false);
  const [selectedAppointment, setSelectedAppointment] =
    useState<TransformedEvent>(initValue);
  const [isLoading, setIsLoading] = useState(false);
  const {
    setAppoitments,
    filteredAppointmnets,
    setFilteredAppointmnets,
    setPdfIntroData,
  } = useCallbackState();

  useEffect(() => {
    fetchData({ setAppoitments, setFilteredAppointmnets });
    getPdfIntroData(setPdfIntroData);
  }, [setAppoitments, setFilteredAppointmnets, setPdfIntroData]);

  const handleFilterClick = () => {
    setFilter(!filter);
  };

  const handleButtonClick = () => {
    setShowPicker(!showPicker);
  };

  const openPopup = (event: TransformedEvent) => {
    if (event) {
      setSelectedAppointment(event);
    }
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const { formats } = useMemo(
    () => ({
      formats: {
        weekdayFormat: (
          date: Date,
          culture: Culture | undefined,
          localizer: any
        ) => localizer.format(date, "dddd", culture),
        dateFormat: (
          date: Date,
          culture: Culture | undefined,
          localizer: any
        ) => localizer.format(date, "D", culture),
      },
    }),
    []
  );

  const eventPropGetter = useCallback(
    (event: TransformedEvent) => ({
      ...{
        style: {
          backgroundColor: getColor(event.resource.topic.replace(/&/g, " & ")),
        },
      },
    }),
    []
  );

  return (
    <div className="calendar-container">
      <Header
        openOutlookDownload={handleButtonClick}
        handleFilterClick={handleFilterClick}
        setIsLoading={setIsLoading}
      />
      <div>
        <Calendar
          localizer={localizer}
          events={filteredAppointmnets}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 500 }}
          onSelectEvent={openPopup}
          views={["month", "agenda"]}
          messages={germanTranslations}
          formats={formats}
          popup={true}
          popupOffset={{ x: 0, y: 10 }}
          eventPropGetter={eventPropGetter}
        />
        {isLoading && <Spinner />}
      </div>
      {isPopupOpen && (
        <AppointmentDetails
          closePopup={closePopup}
          selectedAppointment={selectedAppointment}
        />
      )}
      {showPicker && <DateRangePicker closePopup={handleButtonClick} />}
      {filter && <FilterAppointments closePopup={handleFilterClick} />}
    </div>
  );
};

export default FirmCalendar;
